import { ResearchRole } from '../shared/global-enums';

export const USER_GUIDE_PERMITTED_ROLES = [
    ResearchRole.Administrator,
    ResearchRole.Editor,
    ResearchRole.Contributor,
    ResearchRole.Subscriber,
];
